import { Tile } from "../../../common/Tile";
import { compareObjects } from "../../../utils/compareObjects";

export const Concepts = ({ data }) => {
  if (!data || !data.ideas || !data.ideas.result) {
    return null;
  }

  return (
    <Tile
      data={{
        companyStatus: data.companyStatus,
        features: {
          tileHeader: "Koncepcje",
          optionalFeatures: false,
          result: data.ideas.result.sort(compareObjects),
        },
      }}
    />
  );
};
